// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Currency from "../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Belt_Array from "../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as ConfirmOrderForm from "./ConfirmOrderForm.bs.js";
import * as PlaceOrderFooter from "../shared/PlaceOrderFooter.bs.js";
import * as PlaceOrderContext from "../../context/PlaceOrderContext.bs.js";
import * as PlaceOrderPayload from "../../../app/api-model/PlaceOrderPayload.bs.js";
import * as FormInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as PlaceOrderGaConfig from "../../../app/helper/PlaceOrderGaConfig.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as PlaceOrderCouponCmp from "./PlaceOrderCouponCmp.bs.js";
import * as PlaceOrderSummaryCmp from "./PlaceOrderSummaryCmp.bs.js";
import * as PlaceOrderDataMachine from "../../../app/data-machine/PlaceOrderDataMachine.bs.js";
import * as FormSelectInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectInput.bs.js";
import * as SelectComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/drop-downs/SelectComponent.bs.js";
import * as FormSingleCheckBoxInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSingleCheckBoxInput.bs.js";

function ConfirmOrderFormCmp(Props) {
  var vehicle = Props.vehicle;
  var onPlaceOrderSuccess = Props.onPlaceOrderSuccess;
  var setLoading = Props.setLoading;
  var match = PlaceOrderContext.useContext(undefined);
  var dispatch = match.dispatch;
  var state = match.state;
  var match$1 = React.useState(function () {
        return false;
      });
  var setAssignManually = match$1[1];
  var assignManually = match$1[0];
  var match$2 = CountryContext.useContext(undefined);
  var country = match$2.country;
  var symbol = CountryConfig.getSymbol(country);
  var selectedGoodsType = state.selectedGoodsType;
  var parentOrderId = state.parentOrderId;
  var wayPointThree = state.wayPointThree;
  var wayPointTwo = state.wayPointTwo;
  var wayPointOne = state.wayPointOne;
  var customerInfo = state.customerInfo;
  var geo_region = state.geo_region;
  var dropAddress = state.dropAddress;
  var pickupAddress = state.pickupAddress;
  var goodsTypeList = List.map((function (e) {
          return {
                  key: e.name,
                  value: String(e.id),
                  text: e.name
                };
        }), $$Array.to_list(vehicle.goods_type));
  var init = ConfirmOrderForm.Form.initialInput;
  var form = ConfirmOrderForm.Form.useForm({
        good_type: init.good_type,
        comment: init.comment,
        assign_driver_manually: assignManually
      }, (function (output, param) {
          var goods_type = output.good_type;
          Curry._1(setLoading, true);
          if (geo_region !== undefined) {
            var data = PlaceOrderPayload.getData(pickupAddress, dropAddress, geo_region.id, vehicle, goods_type, state.customerInfo, wayPointOne, wayPointTwo, wayPointThree, parentOrderId, assignManually);
            return PlaceOrderDataMachine.placeOrder(data, country, (function (res) {
                          PlaceOrderGaConfig.publishEvent({
                                category: /* ConfirmOrder */3,
                                action: "Confirm Order Sucess",
                                label: "1_" + res.order_crn + "#2_" + customerInfo.mobile,
                                value: undefined,
                                nonInteraction: undefined
                              }, country);
                          Curry._1(setLoading, false);
                          return Curry._2(onPlaceOrderSuccess, res, assignManually);
                        }), (function (error) {
                          PlaceOrderGaConfig.publishEvent({
                                category: /* ConfirmOrder */3,
                                action: "Confirm Order Failure",
                                label: "1_" + ErrorUtils$Catalyst.resolveError(error) + "\n                }#2_" + customerInfo.mobile,
                                value: undefined,
                                nonInteraction: undefined
                              }, country);
                          Curry._1(setLoading, false);
                          return Curry._1(dispatch, {
                                      TAG: /* OpenSnackbar */8,
                                      snackbar_message: {
                                        TAG: /* Error */1,
                                        _0: ErrorUtils$Catalyst.resolveError(error)
                                      }
                                    });
                        }));
          }
          Curry._1(setLoading, false);
          return Curry._1(dispatch, {
                      TAG: /* OpenSnackbar */8,
                      snackbar_message: {
                        TAG: /* Error */1,
                        _0: "Something went wrong"
                      }
                    });
        }));
  var upcomingGoods = function (param) {
    console.log(vehicle, selectedGoodsType);
    if (selectedGoodsType === undefined) {
      return ;
    }
    var goodsObj = vehicle.goods_type.find(function (e) {
          return e.id === selectedGoodsType;
        });
    var finalGoods = goodsObj !== undefined ? ({
          key: goodsObj.name,
          value: String(goodsObj.id),
          text: goodsObj.name
        }) : undefined;
    return Curry._2(form.updateGood_type, (function (input, value) {
                  return {
                          good_type: value,
                          comment: input.comment,
                          assign_driver_manually: input.assign_driver_manually
                        };
                }), finalGoods);
  };
  React.useEffect((function () {
          upcomingGoods(undefined);
          
        }), []);
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "vehicle_details_container"
                }, React.createElement("div", {
                      className: "vehicle"
                    }, React.createElement("div", {
                          className: "left"
                        }, React.createElement("img", {
                              src: ""
                            }), React.createElement("div", undefined, React.createElement("p", {
                                  className: "vehicle__name"
                                }, vehicle.vehicle_name), React.createElement("p", {
                                  className: "vehicle__size"
                                }, Belt_Array.map(vehicle.details, (function (capacityDetails) {
                                        return React.createElement("div", {
                                                    key: capacityDetails.key,
                                                    className: "label"
                                                  }, capacityDetails.value);
                                      }))))), React.createElement("p", {
                          className: "right"
                        }, Currency.toCurrencyString(vehicle.bill_details.amount_payable, symbol))), React.createElement(FormSelectInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("Select Goods type", (function ($$event) {
                              var goods = SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), goodsTypeList);
                              Curry._1(dispatch, {
                                    TAG: /* SetGoodsType */4,
                                    _0: goods
                                  });
                              PlaceOrderGaConfig.publishEvent({
                                    category: /* ConfirmOrder */3,
                                    action: "Select Goods",
                                    label: "1_" + FormHelper$Catalyst.TargetEventWrapper.value($$event) + "#2_" + customerInfo.mobile,
                                    value: undefined,
                                    nonInteraction: undefined
                                  }, country);
                              return Curry._2(form.updateGood_type, (function (input, value) {
                                            return {
                                                    good_type: value,
                                                    comment: input.comment,
                                                    assign_driver_manually: input.assign_driver_manually
                                                  };
                                          }), goods);
                            }), undefined, undefined, undefined, undefined, undefined, undefined, form.good_typeResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      select_props: {
                        value: form.input.good_type,
                        items: goodsTypeList,
                        isNoneRequired: true
                      }
                    })), React.createElement(PlaceOrderCouponCmp.make, {
                  coupon: vehicle.fare_info.applied_coupon
                }), React.createElement("p", {
                  className: "payment_label"
                }, "Payment Summary"), React.createElement(PlaceOrderSummaryCmp.make, {
                  fare_info: vehicle.fare_info,
                  bill_details: vehicle.bill_details
                }), React.createElement("div", {
                  className: "assign_driver_section"
                }, React.createElement(FormSingleCheckBoxInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              return Curry._2(form.updateAssign_driver_manually, (function (input, value) {
                                            Curry._1(setAssignManually, (function (param) {
                                                    return value;
                                                  }));
                                            return {
                                                    good_type: input.good_type,
                                                    comment: input.comment,
                                                    assign_driver_manually: value
                                                  };
                                          }), FormHelper$Catalyst.TargetEventWrapper.checked($$event));
                            }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      checked: form.input.assign_driver_manually,
                      label: "Assign Driver Manually"
                    })), React.createElement("div", {
                  className: "comment_section"
                }, React.createElement("p", {
                      className: "label"
                    }, "Comments (Optional)"), React.createElement("textarea", {
                      className: "comment_text_field",
                      placeholder: "Add comments if any"
                    })), React.createElement(PlaceOrderFooter.make, {
                  handleNextButton: (function (param) {
                      PlaceOrderGaConfig.publishEvent({
                            category: /* ConfirmOrder */3,
                            action: "Next",
                            label: "1_" + customerInfo.mobile,
                            value: undefined,
                            nonInteraction: undefined
                          }, country);
                      return Curry._1(form.submit, undefined);
                    }),
                  handleBackButton: (function (param) {
                      PlaceOrderGaConfig.publishEvent({
                            category: /* ConfirmOrder */3,
                            action: "Back",
                            label: "1_" + customerInfo.mobile,
                            value: undefined,
                            nonInteraction: undefined
                          }, country);
                      return Curry._1(dispatch, {
                                  TAG: /* ChangeCurrentStep */0,
                                  _0: /* VehicleSelectionStep */1
                                });
                    }),
                  showBackButton: true,
                  showFare: true,
                  fare: vehicle.bill_details.amount_payable
                }));
}

var make = ConfirmOrderFormCmp;

export {
  make ,
  
}
/* react Not a pure module */
